export type SupervisiBdrsHasil = "ya" | "tidak" | "na" | null;

export type SupervisiBdrsKategori =
  | "hand_hygiene"
  | "apd"
  | "limbah"
  | "darah"
  | "kebersihan";

export interface SupervisiBdrsItem {
  id: number;
  kategori: SupervisiBdrsKategori;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: SupervisiBdrsHasil;
  masalah: string | null;
  rekomendasi: string | null;
}

export interface UserRef {
  id: number;
  nama: string | null;
}

export interface SupervisiBdrs {
  id: number;
  nomor_formulir: string | null;
  tanggal_supervisi: string;
  waktu_mulai: string | null;
  waktu_selesai: string | null;

  supervisor_user_id: number;
  supervisor: UserRef | null;
  supervisor_jabatan: string | null;
  signed_supervisor: boolean;
  signed_supervisor_at: string | null;

  kepala_unit_user_id: number | null;
  kepala_unit: UserRef | null;
  kepala_unit_nama_manual: string | null;
  signed_kepala_unit: boolean;
  signed_kepala_unit_at: string | null;

  temuan_utama: string | null;
  rencana_tindak_lanjut: string | null;

  is_locked: boolean;
  items?: SupervisiBdrsItem[];

  created_at: string;
  updated_at: string;
}

export const KATEGORI_LABEL: Record<SupervisiBdrsKategori, string> = {
  hand_hygiene: "I.   Supervisi Kepatuhan Hand Hygiene",
  apd: "II.  Supervisi Penggunaan APD",
  limbah: "III. Supervisi Pengelolaan Limbah Infeksius",
  darah: "IV.  Supervisi Penanganan Darah dan Komponen Darah",
  kebersihan: "V.   Supervisi Kebersihan dan Dekontaminasi Lingkungan",
};
